import axios from 'axios';

// Create axios instance
const api = axios.create({
  //baseURL: 'http://192.168.101.200:8000/api', // your backend API base URL
  baseURL: 'https://skillspark.your-product.in/api',
});

// Add token automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token'); // match your login key
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ✅ Response Interceptor: handle 401 errors (unauthorized)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('auth_token'); // clear invalid token
      window.location.href = '/admin-login'; // redirect to admin login
    }
    return Promise.reject(error);
  }
);


export default api;
